var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69787 0.206994C8.72615 0.152879 8.76688 0.106254 8.8167 0.0709563C8.86652 0.0356588 8.92401 0.0126982 8.98444 0.00396466C9.04487 -0.00476889 9.10651 0.000974323 9.16428 0.0207215C9.22206 0.0404687 9.27432 0.0736553 9.31676 0.117549L9.76676 0.416438C9.87445 0.498921 9.95243 0.614145 9.98898 0.744772C10.0006 0.906457 9.95039 1.06653 9.84843 1.19255L4.93009 9.10533C4.81898 9.28477 4.73343 9.40422 4.64898 9.52366C4.57832 9.63464 4.48188 9.72689 4.36787 9.79255C4.28073 9.85383 4.1863 9.90403 4.08676 9.94199C3.98763 9.97894 3.88307 9.99921 3.77732 10.002C3.58515 9.99743 3.39886 9.93488 3.24287 9.82255C2.99991 9.64115 2.79047 9.41874 2.62398 9.16533L0.0934278 5.58255C0.0547733 5.54424 0.0266836 5.49659 0.0118871 5.44421C-0.00290946 5.39184 -0.00390975 5.33653 0.00898335 5.28366C0.0383204 5.19494 0.0862377 5.1135 0.149539 5.04477L0.683983 4.56699C0.750207 4.49647 0.840773 4.45377 0.937317 4.44755C1.03156 4.46193 1.11959 4.50343 1.19065 4.56699L3.63509 6.62755L8.69787 0.206994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/check-black.3dad205ba6ea79116cbed9cd126f9fd9.svg";
export { ForwardRef as ReactComponent };